import baby from "./assets/images/baby.png"
import tacowoman from "./assets/images/crunchintolife.jpg"
import staffpick from "./assets/images/staffpick.jpg"
import drinks from "./assets/images/Drinks.jpg"
import desserts from "./assets/images/dessert.jpg"
import chips from "./assets/images/chips.jpg"
import cereal from "./assets/images/cereal.jpg"
import cookies from "./assets/images/cookies.jpg"


export const sliderItems = [
  {
    id: 1,
    img: baby,
    alt: " ",
    title: "SATISFY YOUR SWEET TOOTH!",
    desc: "START SKIPPING DINNER! GET FREE SHIPPING ON ALL DESSERTS.",
    bg: "fbf4ea",
  },
  {
    id: 2,
    img: staffpick,
    alt: " ",
    title: "CHECK OUT OUR STAFF PICKS!",
    desc: "WE REALLY GO BEYOND JUST SNACKS",
    bg: "F0F1F3",
  },
  {
  id: 3,
  img: tacowoman,
  alt: " ",
  title: "TAKE A BITE OUT OF LIFE!",
  desc: "CRUNCHY NEW SNACKS ARE WAITING FOR YOU!",
  bg: "fbf0f4",
  },


]

export const categories = [
    {
        id: 1,
        img: desserts,
        title: "Desserts",
        cat: "desserts"
    },
    {
        id: 2,
        img: chips,
        title: "Chips",
        cat: "chips"
    },
    {
        id: 3,
        img: cookies,
        title: "Cookies",
        cat: "cookies"
    },
    {
        id: 4,
        img: cereal,
        title: "Cereal",
        cat: "cereal"
    },
    {
        id: 5,
        img: drinks,
        title: "Drinks",
        cat: "drinks"
    },
]
